import React, { useState } from 'react';
import { CopyIcon, CheckIcon, InvitationIcon } from '../../assets/imageAssets';
import Tag from "../../components/Tag";
import Input from "../../components/Input";
import Button from "../../components/Button";
import { useAmbassadorRegisterMutation } from '../../api/mutations/ambassadors.mutation';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ambassadorRegisterSchema } from "../../schemas/schemas";
import Loader from '../../components/Loader';
import { useSelector } from 'react-redux';

const InvitationModal = () => {
    const invitationData = useSelector((state) => state.invitation.data);
    const [copied, setCopied] = useState(false);

    const handleCopyLink = () => {
        navigator.clipboard.writeText(invitationData?.referral_link);
        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
    };

    console.log(invitationData);

    return (
        <div className="modal-body">
            <img src={InvitationIcon} alt="Invitation Icon" className="award-icon" />
            <Tag text="Invite & Earn" color="red" dot={false} />
            <h2 className='mb-8'>Simple sharing. Real rewards.</h2>
            <p className='mb-16'>Invite friends using your personal link. When they subscribe, both of you get the first month free.</p>
            <div className="referal-link-box flex flex-align-center flex-between flex-wrap mb-16">
                <div>
                    <span>Your referral link</span>
                    <h6>{invitationData?.referral_link}</h6>
                </div>
                {!copied ?
                    <Button
                        text={"Copy Link"}
                        icon={<img src={CopyIcon} width={20} height={20} alt="Alert" className="mr-8" />}
                        onClick={handleCopyLink}
                    /> : 
                    <div className="copied-text flex flex-align-center">
                        <img src={CheckIcon} width={20} height={20} alt="Alert" className="mr-8" />
                        Link Copied
                    </div>
                }
            </div>
            <div className="referal-link-info">
                Share on social, in group chats, or add to your bio.
            </div>
        </div>
    );
}

export default InvitationModal;